import Home from '../pages/master/Home';
import AddCompany from '../pages/master/AddCompany';
import MasterMenu from '../pages/master/MasterMenu';

const MasterRoutes = [
  { path: '/softwareadmin', element: <Home />, exact: true },
  { path: '/softwareadmin/home', element: <Home />, exact: true },
  { path: '/softwareadmin/add-company', element: <AddCompany />, exact: true },
  { path: '/softwareadmin/add-menu', element: <MasterMenu />, exact: true },
];

export default MasterRoutes;